import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { LazyMarkdown } from '@sorare/core/src/atoms/markdown/LazyMarkdown';
import { ANY_SPORT_MY_CLUB_SLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { DumbNotification } from 'components/activity/DumbNotification';

import { commonNotificationInterfaceFragment } from '../fragments';
import type { UserRelationNotification_userRelationNotification } from './__generated__/index.graphql';

type Props = {
  notification: UserRelationNotification_userRelationNotification;
};

export const UserRelationNotification = ({ notification, ...rest }: Props) => {
  const { generateSportContextPath } = useSportContext();

  const { createdAt, name, read, userRelation } = notification;
  const { user, knownUser } = userRelation;

  let relatedUser;

  switch (name) {
    case 'user_relation_followed':
      relatedUser = user;
      break;
    case 'user_relation_revealed':
      relatedUser = knownUser;
      break;
    default:
  }

  if (!relatedUser) return null;

  const link = generateSportContextPath(ANY_SPORT_MY_CLUB_SLUG, {
    params: {
      slug: relatedUser.slug,
    },
  });

  return (
    <DumbNotification
      name={name}
      title={<LazyMarkdown data={notification.markdownBody} />}
      userAvatar={relatedUser}
      link={link}
      createdAt={createdAt}
      read={read}
      sport={null}
      {...rest}
    />
  );
};

UserRelationNotification.fragments = {
  userRelationNotification: gql`
    fragment UserRelationNotification_userRelationNotification on UserRelationNotification {
      id
      ...Notification_notificationInterface
      userRelation {
        id
        user {
          slug
          ...DumbNotification_userAvatar
        }
        knownUser {
          slug
          ...DumbNotification_userAvatar
        }
      }
    }
    ${commonNotificationInterfaceFragment}
    ${DumbNotification.fragments.avatarUser}
  ` as TypedDocumentNode<UserRelationNotification_userRelationNotification>,
};
